import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { CompanyForm } from "@modules/companies/components/CompanyForm";
import { useCompanyCreateForm } from "./controller";

export const CompanyCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useCompanyCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <CompanyForm />
      </FormProvider>
    </Create>
  );
});
